import React from "react";
import styles from "./FloatingPartnerLogos.module.css";
import { Img } from "../elements/Img";

const FloatingPartnerLogos = () => {
  return (
    <div className={styles.floatingLogos}>
      <div className={styles.logoItem}>
        <Img src="/waff_stadtwien_logo_neu_RGB.png" alt="WAFF Stadt Wien Logo" />
      </div>
      <div className={styles.logoItem}>
        <Img src="/wien_cert_logo_200px.jpg" alt="Wien Cert Logo" />
      </div>
    </div>
  );
};

export default FloatingPartnerLogos;